import { render, staticRenderFns } from "./OrderDetailsFoodCard.vue?vue&type=template&id=7b1de4a1&scoped=true"
import script from "./OrderDetailsFoodCard.vue?vue&type=script&lang=js"
export * from "./OrderDetailsFoodCard.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsFoodCard.vue?vue&type=style&index=0&id=7b1de4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1de4a1",
  null
  
)

export default component.exports